import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

const ModernStoryPage = lazy(
  () =>
    import('./StoryPage.eager').then(mod => ({
      default: mod.StoryPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);

const LegacyStoryPage = lazy(
  () =>
    import('../../../../bridge/pages/StoryPage.eager').then(mod => ({
      default: mod.StoryPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);

export const StoryPage: React.FC = () => {
  const isStoryPageMigrationEnabled = useIsFeatureActive(
    'enable_new_story_page',
  ).isActive;

  return isStoryPageMigrationEnabled ? (
    <ModernStoryPage />
  ) : (
    <LegacyStoryPage />
  );
};
